module.exports = __webpack_public_path__ + "img/shell.b7f0188f.png";